import {
  COMPANY_FETCHED,
  COMPANY_UPDATED,
  COMPANY_DELETED,
} from 'constants/actions';
import apiClient from 'apiClient';

function companyFetched(company) {
  return {
    type: COMPANY_FETCHED,
    company,
  };
}

function companyUpdated(company) {
  return {
    type: COMPANY_UPDATED,
    company,
  };
}

function companyDeleted(companyId) {
  return {
    type: COMPANY_DELETED,
    companyId,
  };
}

function setCompanyFromJson() {
  return {
    type: COMPANY_FETCHED,
    company: window.gon.current_company_json,
  };
}

function fetchCompany(companyId) {
  return (dispatch) => {
    apiClient.get(`companies/${companyId}`).then((company) => {
      dispatch(companyFetched(company));
      return company;
    });
  };
}

function updateCompany(companyId, company) {
  return (dispatch) => {
    apiClient
      .put(`companies/${companyId}`, { company })
      .then((updatedCompany) => {
        dispatch(companyUpdated(updatedCompany));
        return updateCompany;
      });
  };
}

function updateCompanyLogo(companyId, logo) {
  return (dispatch) => {
    const data = new FormData();
    data.append('logo', logo);

    const path = `companies/${companyId}/logo`;
    return apiClient
      .post(path, data, { headers: { 'Content-Type': undefined } })
      .then((company) => {
        dispatch(companyUpdated(company));
        return company;
      });
  };
}

function deleteCompanyLogo(companyId) {
  return (dispatch) => {
    return apiClient.delete(`/companies/${companyId}/logo`).then(() => {
      return dispatch(fetchCompany(companyId));
    });
  };
}

function deleteCompanyAccount(companyId) {
  return (dispatch) => {
    const path = `companies/${companyId}`;
    return apiClient.delete(path).then(() => {
      dispatch(companyDeleted(companyId));
      return companyId;
    });
  };
}

export {
  fetchCompany,
  updateCompany,
  updateCompanyLogo,
  deleteCompanyAccount,
  deleteCompanyLogo,
  setCompanyFromJson,
};
